import {
  TransactionType,
  TransactionValue,
} from '@/reducers/transactionReducer'
import { getHasRegulatedCadcContract, NetworkValue } from '@/utils/currencies'

type CadcRestrictionInput = {
  transactionType: TransactionValue
  enableSendNewCadc: boolean
  enableRejectOldCadc: boolean
}

export const getIsCadcRestricted = ({
  transactionType,
  enableSendNewCadc,
  enableRejectOldCadc,
}: CadcRestrictionInput) =>
  transactionType === TransactionType.BUY
    ? enableSendNewCadc
    : enableRejectOldCadc

export const getIsCadcBlockedOnNetwork = ({
  network,
  ...restriction
}: CadcRestrictionInput & { network: NetworkValue }) =>
  getIsCadcRestricted(restriction) && !getHasRegulatedCadcContract(network)
